import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Divided-module_divided__jfy5r {\n  display: flex;\n  flex-grow: 1;\n}\n.Divided-module_divided__jfy5r > :not(.p-divider) {\n  min-width: 25%;\n}\n.Divided-module_divided__jfy5r > :first-child {\n  flex: 1;\n}";
var s = {"divided":"Divided-module_divided__jfy5r"};
styleInject(css_248z);

export { s as default };
